module.exports = __webpack_public_path__ + "img/banner-standapp.904ef9ce.svg";